import angular from 'angular';

export default function Notes(Restangular, EventCollection, RenderContent, dateFilter) {
  'ngInject';

  Restangular.extendModel('shifts/notes', (note) => {
    if (note.content) {
      note.renderedContent = RenderContent.get(note.content);
    }

    if (note.user) {
      note.user = Restangular.restangularizeElement(null, note.user, 'users');
    }

    return note;
  });

  Restangular.addRequestInterceptor((element, operation, what) => {
    if (what === 'shifts/notes' && (operation === 'post' || operation === 'put')) {
      const copy = angular.copy(element);
      copy.date = dateFilter(copy.date, 'yyyy-MM-dd');
      return copy;
    }

    if (what === 'shifts/notes' && operation === 'remove') {
      // Do NOT send a payload for the DELETE, see https://github.com/getsling/sling-server/issues/1369
      return null;
    }

    return element;
  });

  // Update EventCollection based on server response
  Restangular.addResponseInterceptor((data, operation, what) => {
    if (what === 'shifts/notes') {
      if (operation === 'post' || operation === 'put') {
        EventCollection.addOrEditNote(data);
      }

      if (operation === 'remove') {
        EventCollection.deleteNote(data);
      }
    }

    return data;
  });

  return Restangular.service('shifts/notes');
}
